import { Component, input, output } from "@angular/core";
import { IAllSearch, StatusInfo } from "../../../interfaces";
import { MatDialog } from "@angular/material/dialog";
import { NgClass } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { HighlightDirective } from "../../directives/highlight.directive";
import { RouterLink } from "@angular/router";

@Component({
    selector: "carrier-result",
    templateUrl: "./carrier-result.component.html",
    styleUrl: "./carrier-result.component.scss",
    imports: [
        NgClass,
        MatIcon,
        MatMiniFabButton,
        MatTooltip,
        MatMenuTrigger,
        HighlightDirective,
        MatMenu,
        MatMenuItem,
        RouterLink,
    ],
})
export class CarrierResultComponent {
    item = input.required<IAllSearch>();
    searchTerm = input.required<string>();
    shortcutClick = output<void>();

    constructor(private dialog: MatDialog) {}

    get fullAddress(): string {
        const parts = [this.item().Address1, this.item().City, this.item().State, this.item().ZIP].filter(Boolean);

        return parts.join(", ");
    }

    get primaryId(): string {
        return `${this.item().ID} - ${this.item().Name}`;
    }

    get carrierStatus(): StatusInfo {
        const { Blocked, WarningMessage } = this.item();

        if (WarningMessage) {
            return { level: "danger", text: WarningMessage };
        }

        if (Blocked) {
            return { level: "danger", text: "Blocked" };
        }

        return { level: "normal" };
    }

    get backgroundClass(): string {
        const status = this.carrierStatus;
        if (status.level === "danger") return "carrier-danger";
        if (status.level === "warning") return "carrier-warning";

        return "";
    }

    gridButton() {
        this.shortcutClick.emit();
    }

    contactButton() {
        this.shortcutClick.emit();
        this.carrierContacts(this.item().ID);
    }

    carrierContacts(id: number) {
        import("../../../Dispatch/Load/driver-contact-dialog/driver-contact-dialog.component").then(
            ({ DriverContactDialogComponent }) => {
                this.dialog.open(DriverContactDialogComponent, {
                    width: "900px",
                    data: {
                        branchID: null,
                        carrier: null,
                        contacts: null,
                        carrierId: id,
                    },
                });
            }
        );
    }
}
